module.exports = __webpack_public_path__ + "static/media/BTC-BRL.a1b10b3a.svg";